import "./Gallery.css"
import ImgCardContainer from "./ImgCardContainer/ImgCardContainer"
import Description from "./Description/Description"
import GalleryHeader from "./Header/GalleryHeader"
import SeparatingLine from "./SeparatingLine/SeparatingLine"

function Gallery() {
  return (
    <div className="Gallery">
      <GalleryHeader />
      <Description />
      <SeparatingLine />
      <ImgCardContainer />
    </div>
  )
}

export default Gallery
